export const foldersSlug = 'payload-folders'
export const parentFolderFieldName = 'folder'
